import Vue from 'vue';
import App from './App';
import router from './router';

import store from './Store';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'wowjs/css/libs/animate.css';
import 'animate.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// import 'babel-polyfill';
// import Promise from 'es6-promise';
// require('es6-promise').polyfill();
// Promise.polyfill();

// import VueResource from 'vue-resource';
// import global from './assets/glob/global';
// // 公共方法
// import GHRequest from './assets/glob/GHRequest';
// //请求异常封装
// import axios from './common/axios';
// Vue.prototype.$axioshttp = axios;
// Vue.use(VueResource);
// Vue.config.productionTip = false;
// Vue.prototype.GHRequest = GHRequest;
// Vue.prototype.global = global;

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
		var data = {
			fIndex: to.meta.fIndex,
			cIndex: to.meta.cIndex
		};
		store.commit('updateSelect', data);
		$('html, body').animate({ scrollTop: '0' }, 0);
	}
	next();
});
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js